module.exports = __webpack_public_path__ + "bf1.no1.ab4f0643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/bf1.no1.jpg
// module id = K6tj
// module chunks = 0